import { useTranslation } from "react-i18next";
import Logo from "./Logo";
import SearchForm from "./search/SearchForm";
import Menu from "./menu/Menu";

// import colors from "utils/scss-utils/_colors.module.scss";
import "./Header.scss";
import { useEffectDeviceAndOrientation } from "utils/hooks";
import HeaderIcons from "./icons/HeaderIcons";

const Header = () => {
  const { t } = useTranslation("header", { useSuspense: false });
  const [device, orientation] = useEffectDeviceAndOrientation();

  //ne koristi se ali dobar primer menjanja boje
  // const getHeaderRowFullColor = () => {
  //   if (device === "computer" && orientation === "landscape") {
  //     return colors.blackColor;
  //   } else if (device === "computer" && orientation === "portrait") {
  //     return colors.lightColor;
  //   } else if (device === "mobile") {
  //     return colors.lightColor;
  //   } else {
  //     return colors.lightColor;
  //   }
  // };

  return (
    <header className="Header">
      <div className="Header1">
        <div className="Header1-Content">
          <p>{t("header1_text1")}</p>
          <p>{t("header1_text2")}</p>
          <p>{t("header1_text3")}</p>
        </div>
      </div>
      <div className="Header2">
        <div className="Header2-Item1">
          {device === "computer" && orientation === "landscape" && (
            <Logo type="Desktop" />
          )}
          {device === "computer" && orientation === "portrait" && <Menu />}
          {device === "mobile" && <Menu />}
        </div>
        <div className="Header2-Item2">
          {device === "computer" && orientation === "landscape" && (
            <SearchForm />
          )}
          {device === "computer" && orientation === "portrait" && (
            <Logo type="Mobile" />
          )}
          {device === "mobile" && <Logo type="Mobile" />}
        </div>
        <div className="Header2-Item3">
          <HeaderIcons />
        </div>
      </div>
      <div className="Header3">
        {device === "computer" && orientation === "landscape" && <Menu />}
        {device === "computer" && orientation === "portrait" && <SearchForm />}
        {device === "mobile" && <SearchForm />}
      </div>
    </header>
  );
};
export default Header;
